// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "foxit-UIExtension-full" + "." + "9ee5b89dec60673e" + ".js";
};